import React from 'react';
import { Badge } from '../core/Badge.jsx';
import { PlayButton } from '../player/PlayButton.jsx';
import { CoverTile } from './CoverTile.jsx';

/** Grid episode card: square cover with hover play, 2-line title, mono meta. */
export function EpisodeCard({ episode, locked = false, playing = false, onPlay, onOpen, className = '', style }) {
  const ep = episode || {};
  return (
    <div className={`bjl-epcard ${className}`} style={style} onClick={() => onOpen && onOpen(ep.id)}>
      <span className="bjl-epcard__cover">
        <CoverTile vol={ep.vol} size="100%" seed={ep.id} image={ep.cover} fallback={ep.coverFallback} style={{ width: '100%', height: '100%', borderRadius: 0 }} />
        {ep.memberOnly ? (
          <span className="bjl-epcard__badges">
            <Badge variant="member" />
          </span>
        ) : null}
        <span className="bjl-epcard__play" onClick={(e) => e.stopPropagation()}>
          <PlayButton size="sm" playing={playing} onClick={() => onPlay && onPlay(ep.id)} />
        </span>
      </span>
      <span className="bjl-epcard__title">{ep.title}</span>
      <span className="bjl-epcard__meta">
        {[
          ep.vol != null ? `Vol.${ep.vol}` : null,
          ep.durationMin != null ? `${ep.durationMin} 分钟` : null,
          ep.date || null,
        ]
          .filter(Boolean)
          .map((m, i) => (
            <React.Fragment key={m}>
              {i > 0 ? <span>·</span> : null}
              <span>{m}</span>
            </React.Fragment>
          ))}
      </span>
    </div>
  );
}
